function sigedDialogHeader(title, type = null) {
  const iconType = {
    warning: {
      color: 'red',
      name: 'warning',
    },
    info: {
      color: 'blue',
      name: 'info',
    },
    notification: {
      color: 'orange',
      name: 'notification_important',
    },
  };
  const modalHeader = document.createElement('div');
  modalHeader.className = `titleModal v-card__title ${iconType[type].color}`; // headline
  const modalTitle = document.createElement('span');
  modalTitle.innerHTML = title;
  modalTitle.style = 'outline:none; font-size: 22px; color: white;';
  if (type !== null) {
    const modalIcon = document.createElement('i');
    modalIcon.setAttribute('aria-hidden', true);
    modalIcon.className = 'v-icon outline-icon-right material-icons theme--light';
    modalIcon.style = 'margin-right: 10px; color: rgba(0,0,0,.3);';
    modalIcon.innerHTML = iconType[type].name;
    modalHeader.appendChild(modalIcon);
  }
  modalHeader.appendChild(modalTitle);
  return modalHeader;
}

function sigedDialogText(text) {
  if (!text) {
    return;
  }

  const modalText = document.createElement('div');
  modalText.setAttribute('id', 'textoModal');
  modalText.setAttribute('tabindex', '1');
  modalText.className = 'textModal v-card__text pa-4';
  modalText.innerHTML = text;
  return modalText;
}

function sigedDialogAction(buttons) {
  const modalActionSpacer = document.createElement('div');
  modalActionSpacer.className = 'spacer';

  const modalAction = document.createElement('div');
  modalAction.className = 'v-card__actions py-4';

  modalAction.appendChild(modalActionSpacer);

  for (const [i,btn] of buttons.entries()) {
    const modalButton = document.createElement('button');
    modalButton.setAttribute('id', btn.text + 'buttonModal');
    modalButton.setAttribute('tabindex', i + 2);
    modalButton.className = `v-btn font-weight-regular v-btn--flat theme--light ${((btn.color) ? btn.color : 'gray')}--text text--darken-1`;
    modalButton.type = 'button';
    modalButton.setAttribute('data-click', btn.response);    

    const modalButtonText = document.createElement('div');
    modalButtonText.className = 'v-btn__content text-body-2';
    modalButtonText.innerHTML = (btn.text) ? btn.text : 'Ok';
    modalButtonText.setAttribute('data-click', (btn.response != null) ? btn.response : true);
    modalButton.appendChild(modalButtonText);

    modalAction.appendChild(modalButton);
  }

  return modalAction;
}

function sigedDialog(options) {
  return new Promise((resolve, reject) => {
    const modalBackground = document.createElement('div');
    modalBackground.className = 'modal-animated modal-show-background';
    modalBackground.style = 'z-index: 999;';

    const modalDialog = document.createElement('div');
    modalDialog.className = 'v-dialog__content v-dialog__content--active';
    modalDialog.style = 'z-index: 1000;';
    modalDialog.tabIndex = '-1';

    const modalDialogSize = document.createElement('div');
    modalDialogSize.className = 'v-dialog v-dialog--active modal-animated modal-show';
    modalDialogSize.style = `max-width: ${options.width}`;

    const modalCard = document.createElement('div');
    modalCard.className = 'v-card theme--light';

    const modalDivider = document.createElement('hr');
    modalDivider.className = 'v-divider theme--light';

    const modalHeader = sigedDialogHeader(options.title, options.type);
    if (modalHeader) {
      modalCard.appendChild(modalHeader);
    }

    const modalText = sigedDialogText(options.text);
    if (modalText) {
      modalCard.appendChild(modalText);
    }

    modalCard.appendChild(modalDivider);
    modalCard.appendChild(sigedDialogAction(options.buttons)); // adiciona os botões

    modalDialogSize.appendChild(modalCard);
    modalDialog.appendChild(modalDialogSize);
    modalBackground.appendChild(modalDialog);

    const modalApp = document.getElementsByClassName('v-application');
    modalApp.app.appendChild(modalBackground);
    const titleModal = document.getElementById("textoModal");
    titleModal.focus();
    const modalClick = function (event) {
      const retorno = event.target.getAttribute('data-click');
      if (retorno) {
        modalCard.removeEventListener('click', modalClick);
        modalDialogSize.className += ' modal-hide';
        modalBackground.className += ' modal-hide-background';
        if (retorno === 'true' || retorno === 'false') {
          resolve(retorno === 'true');
        } else {
          resolve(retorno);
        }
        setTimeout(() => modalApp.app.removeChild(modalBackground), 300);
      }
    };
    modalCard.addEventListener('click', modalClick);
  });

}

export default async function sgal(options) {
  if (typeof options !== 'object') {
    options = (typeof options === 'string') ? { text: options } : { };
  }
  const optionsSgal = {
    title: '',
    text: '',
    type: 'info',
    width: '500px',
    buttons: [
      { text: 'Ok', color: 'green', response: true },
    ],
    ...options,
  };
  try {
    const response = await sigedDialog(optionsSgal);
    return response;
  } catch (e) {
    return null;
  }
}
